export type ColorUtilProps = {
  url: string;
  pathname?: string;
};

export const colorUtil = ({url, pathname}: ColorUtilProps) => {
  const bgColor = pathname === url ? 'bg-success-1' : 'bg-white';
  const textColor = pathname === url ? 'text-white' : 'text-success-1';

  return {
    bgColor,
    textColor,
  };
};
